const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);

export function remToPx(rem: number | `${number}rem`) {
    return (typeof rem === "string" ? parseFloat(rem) : rem) * rootFontSize;
}
